import { UserType } from '@awin/shared';

export const userDataMock = {
  user: true,
  sessionToken: 'session-token-mock',
  id: '1001',
  userType: UserType.Advertiser,
};
